import BottomSheet from 'bharat-ui/web/BottomSheet';
import Loader from 'bharat-ui/web/Loader';
import { makeStyles } from 'bharat-ui/web/Styles';
import NotFound from 'components/atoms/NotFound';
import PaymentMethod from 'components/atoms/PaymentMethod';
import React, { useEffect, useState } from 'react';
import {
	usePaymentModes,
	useUpdatedPaymentModes,
	triggerGetCashbackDetailsApi,
	cashbackDetailsSlice,
	useCashbackDetails,
} from 'Slices';
import { triggerGetPaymentModesApi } from 'Slices';
import { useDispatch } from 'react-redux';
import { globalId } from '../../../index';
import Header from 'bharat-ui/web/Header';
import { loadState, saveState } from 'utils/LocalStorage';
import { NativeSupportHandlerV2 } from 'native-support-handler';
import { showPostPeUI, showTwelvePcUI, showUnityUi } from 'utils/Utils';
import LoaderNew from 'components/atoms/Loader';
import { CancelPaymentApi } from 'Services';
import Toasty from 'components/atoms/Toasty';
import HeaderPostPe from 'components/atoms/HeaderPostPe';
import backArrowPostPe from '../../../assets/images/backArrowPostPe.svg';
import { removePostpeLoader, showPostpeLoader } from 'utils/nativeSupport';
import { registerSlice } from 'store';

registerSlice(cashbackDetailsSlice);

const useStyle = makeStyles(() => ({
	mainContainer: {
		background: '#ffffff',
		height: '100vh',
	},
}));
const Home: React.FC = () => {
	const isShowTwelvePcUI = showTwelvePcUI();
	const isShowPostPeUI = showPostPeUI();
	const isShowUnityUi = showUnityUi();
	const isShowAlternateUi = isShowPostPeUI || isShowUnityUi;
	const classes = useStyle();
	const dispatch = useDispatch();
	const postpeCashbackDetailsResponse = useCashbackDetails();
	const [isVisible, setIsVisible] = useState(false);
	const [fullView, setFullView] = useState(false);
	const [paymentModes, setPaymentModes] = useState([]);
	const [isModesVisible, setIsModesVisible] = useState(Boolean);
	const [loading, setLoading] = useState(true);
	const [bankListShown, setBankListShown] = useState(false);
	const usePaymentMode = usePaymentModes();
	const postPaymentModesResponse = useUpdatedPaymentModes();
	const payModes = usePaymentMode?.data?.paymentMethods;

	useEffect(() => {
		setFullView(false);
		setIsVisible(false);
		setIsModesVisible(false);
		setLoading(false);
	}, [usePaymentMode.error.length > 1 && !usePaymentMode.loading]);

	useEffect(() => {
		setFullView(true);
		setIsVisible(true);
		setIsModesVisible(true);
		setPaymentModes(usePaymentMode?.data?.paymentMethods);
		if (isShowPostPeUI && usePaymentMode?.data?.transaction?.orderId) {
			dispatch(triggerGetCashbackDetailsApi(usePaymentMode?.data?.transaction?.orderId));
		}
		setLoading(false); // TODO: check if this has to be removed
	}, [usePaymentMode?.data?.paymentMethods, usePaymentMode?.data?.transaction?.orderId, isShowPostPeUI, dispatch]);

	useEffect(() => {
		if (usePaymentMode?.data?.transaction?.paymentStatus !== 'INIT') {
			handleBack();
		}
		saveState('backUri', usePaymentMode?.data?.transaction?.redirectURI || '', true);
		saveState('backUriDeeplink', usePaymentMode?.data?.transaction?.redirectURIDeeplink || '', true);
	}, [
		usePaymentMode?.data?.transaction?.redirectURI,
		usePaymentMode?.data?.transaction?.redirectURIDeeplink,
		usePaymentMode?.data?.transaction?.paymentStatus,
	]);

	useEffect(() => {
		if (!isShowPostPeUI) return;

		const isPostpeLoading = postpeCashbackDetailsResponse.loading || usePaymentMode?.loading || loading;

		if (isPostpeLoading) {
			showPostpeLoader({ first_message: 'loading', start_index: 0, range: 7, second_message: 'please wait' });
		} else {
			setTimeout(() => removePostpeLoader(), 1500);
		}
	}, [isShowPostPeUI, usePaymentMode?.loading, loading, postpeCashbackDetailsResponse.loading]);

	useEffect(() => {
		if (!isShowUnityUi) return;

		const isPostpeLoading = usePaymentMode?.loading || loading;

		if (isPostpeLoading) {
			showPostpeLoader({ first_message: 'loading', start_index: 0, range: 7, second_message: 'please wait' });
		} else {
			setTimeout(() => removePostpeLoader(), 1500);
		}
	}, [isShowUnityUi, usePaymentMode?.loading, loading]);

	const handleRetry = () => {
		dispatch(triggerGetPaymentModesApi(globalId as any));
	};

	const redirectToSource = () => {
		const deviceType = loadState('deviceType', true);
		if (usePaymentMode?.data?.transaction?.redirectURIDeeplink && deviceType === 'webview') {
			NativeSupportHandlerV2.openDeeplink(usePaymentMode?.data?.transaction?.redirectURIDeeplink);
			return;
		}
		if (usePaymentMode?.data?.transaction?.redirectURI && deviceType === 'browser') {
			window.open(usePaymentMode?.data?.transaction?.redirectURI, '_top');
		}
	};

	const TriggerCancelPaymentApi = () => {
		setLoading(true);
		CancelPaymentApi({ txnId: globalId })
			.then((resp: any) => {
				redirectToSource();
			})
			.catch((err) => {
				redirectToSource();
				Toasty.error('Something went wrong');
			});
	};

	const handleBack = () => {
		if (usePaymentMode?.data?.transaction?.paymentStatus === 'INIT') {
			TriggerCancelPaymentApi();
			return;
		}
		redirectToSource();
	};

	return (
		<div className={isShowTwelvePcUI || isShowAlternateUi ? classes.mainContainer : ''}>
			{!isShowAlternateUi &&
				(isShowTwelvePcUI ? (
					<LoaderNew loading={usePaymentMode?.loading || postPaymentModesResponse?.loading || loading} />
				) : (
					<Loader loading={usePaymentMode?.loading || postPaymentModesResponse?.loading || loading} />
				))}
			{!bankListShown &&
				(isShowAlternateUi ? (
					<HeaderPostPe
						leftIconAction={handleBack}
						title={usePaymentMode?.data?.headerText || ''}
						leftIcon={<img src={backArrowPostPe} />}
					/>
				) : (
					<Header leftIconAction={handleBack} title={usePaymentMode?.data?.headerText || ''} />
				))}
			{isModesVisible && (
				<>
					{fullView ? (
						<>
							{payModes?.length > 0 ? (
								<PaymentMethod
									paymentModes={paymentModes}
									fullScreen={fullView}
									merchantData={usePaymentMode?.data?.merchant}
									bankListCallback={(isVisible) => {
										setBankListShown(isVisible);
									}}
								/>
							) : (
								<div>
									{(payModes?.length === 0 || usePaymentMode?.data == undefined || null) && (
										<NotFound onRetry={() => handleRetry()} />
									)}
								</div>
							)}
						</>
					) : (
						<BottomSheet visible={isVisible} rounded={true} roundRadius={30} onClose={() => setIsVisible(false)}>
							{payModes?.length > 0 ? (
								<PaymentMethod
									paymentModes={paymentModes}
									fullScreen={fullView}
									merchantData={usePaymentMode?.data?.merchant}
									bankListCallback={(isVisible) => {
										setBankListShown(isVisible);
									}}
								/>
							) : (
								<div>
									{(payModes?.length === 0 || usePaymentMode?.data == undefined || null) && (
										<NotFound onRetry={() => handleRetry()} />
									)}
								</div>
							)}
						</BottomSheet>
					)}
				</>
			)}
		</div>
	);
};

export default Home;
